import {h, Fragment} from "preact"
import { useSizeOptions, useLoadMore } from '@nosto/preact'
import { defaultConfig, sizes } from "../config"

const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0

export default () => {
    const { to, size, total } = useSizeOptions(sizes, defaultConfig.serpSize);
    const { loadMore, href } = useLoadMore();

    const store = window.__VPV.store
    const currentBrand = store.currentBrand

    if (currentBrand == 'richer-poorer') {
        isRicherPoorer = true
    } else {
        isRicherPoorer = false
    }

    return (
        <div class="ns-bottom-toolbar ns-d-flex ns-flex-column ns-align-items-center ns-justify-content-center ns-border-box">
            {to < total && 
                <a 
                    class={`ns-load-more-btn ${isRicherPoorer ? 'ns-load-more-rp' : ''}`} 
                    onClick={loadMore}
                    href={href}
                >
                    <span>Load More</span>
                </a>
            }
            <div class="ns-results-view">Showing {to < total ? to : total} of {total}</div>
        </div>
    )
}